"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "HEIDI M.",
  quote: "Meine Woche beginnt Dienstagmorgen - wenn ich hierher komme.",
  position: "MEDITATION, QI GONG, YOGA"
}, {
  author: "Christine C.",
  quote: "Auch mit 83 Jahren kann man offenbar noch Tai Chi und Qi Gong lernen. Ich trainiere viermal die Woche und kann mich mittlerweile bis zu meinen Zehenspitzen hinunterbeugen.",
  position: "Tai Chi, QI GONG, YOGA"
}, {
  author: "WERNER Z.",
  quote: "Seit ich hierherkomme, kann ich endlich meine Schulter wieder viel besser bewegen. ",
  position: "Qi Gong"
}, {
  author: "BETTINA S.",
  quote: "Ich habe früher schon einmal Tai Chi gemacht, aber ich konnte mir nichts merken. Claudia erklärt alles so präzise und anschaulich, dass es sofort Sinn macht. ",
  position: "TAI CHI"
}];
export default function StimmenUnsererKlienten() {
  return <section data-section-id="73928" id="stimmen-unserer-schüler" className="bg-background text-secondary relative overflow-hidden py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.02] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/forest_texture_light.png)] bg-cover bg-center" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                <div className="flex flex-col items-center text-center px-4 md:px-16 lg:px-24">
                  <Quote className="size-10 md:size-14 text-secondary/20 mb-8 md:mb-12" />
                  
                  <blockquote className="font-sans font-light italic text-2xl md:text-4xl lg:text-5xl leading-relaxed md:leading-relaxed lg:leading-relaxed text-secondary mb-12 md:mb-16">
                    "{testimonial.quote}"
                  </blockquote>
                  
                  <div className="mt-auto flex flex-col items-center gap-1">
                    <cite className="font-sans font-normal text-lg md:text-xl text-secondary not-italic tracking-widest uppercase">
                      {testimonial.author}
                    </cite>
                    <span className="font-sans text-xs md:text-sm text-secondary/60 uppercase tracking-widest">
                      {testimonial.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-end gap-4 mt-16 md:mt-24 pr-4 md:pr-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 rounded-full border-[#2C5F63]/20 bg-transparent text-[#2C5F63] hover:bg-[#2C5F63] hover:text-white hover:border-[#2C5F63] transition-all duration-300" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-12 rounded-full border-[#2C5F63]/20 bg-transparent text-[#2C5F63] hover:bg-[#2C5F63] hover:text-white hover:border-[#2C5F63] transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}